export const environment = {
  production: true,
  buildId: '2649538270818181',
  configFile: 'config.json',
};
